export const DORA_PILLARS = [
  { pillar: "ICT Risk Management", description: "Governance, risk framework, controls and monitoring" },
  { pillar: "ICT-Related Incident Reporting", description: "Classification, reporting, notification" },
  { pillar: "Digital Operational Resilience Testing", description: "Testing programs incl. TLPT" },
  { pillar: "ICT Third-Party Risk Management", description: "Vendor oversight, contract clauses, exit" },
  { pillar: "Information Sharing", description: "Threat intelligence and collaboration" },
];
